// extracted by mini-css-extract-plugin
export default {"title":"CardsHub_title__kzkMv","content":"CardsHub_content__lOK87"};